<template>
  <v-container fluid grid-list-xl class="mt-0 pt-0">
    <v-layout wrap>
      <v-flex xs12 xl10 offset-xl1>
        <v-card class="ma-2">
          <v-card-title class="ma-0 pt-0 pb-0 primary--text">
            <h3 class="ma-3">{{ $t('nav.admin.users') }}</h3>
          </v-card-title>
          <v-container fluid grid-list-xl class="mt-0 pt-0">
            <v-layout wrap>
              <v-flex xs12>
                <autotable
                  :columns="columns"
                  :rows="getAdminUsers"
                  @newrow="createUser(...arguments)"
                  @change="updateUser"
                  :delete="userdelete"
                  @delete="deleteUser"
                  dialogtitle="admin.user.createDialog"
                  keyfield="id"
                ></autotable>
              </v-flex>
            </v-layout>
          </v-container>
        </v-card>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
import Vue from "vue";
import Autotable from "../common/autotable/Autotable.vue";
import { mapActions, mapMutations, mapGetters } from "vuex";
import store from "@/store/";
import VueI18n from "../../i18n.js";

export default {
  components: {
    autotable: Autotable
  },
  data() {
    return {
      userdelete: {
        title: "admin.user.deleteTitle",
        text: "admin.user.deleteText",
        fun(user) {
          let name = `<b>${user.email}</b>`;
          return { name };
        }
      }
    };
  },
  computed: {
    ...mapGetters(["getAdminAllUsers", "getLoggedInUser", "getAdminUsers", "getLanguages"]),
    columns() {
      return [
        {
          text: this.$t("admin.user.name"),
          value: "name",
          inputtype: "TEXT",
          maxlength: 50,
          required: true
        },
        {
          text: this.$t("admin.user.surname"),
          value: "surname",
          inputtype: "TEXT",
          maxlength: 50,
          required: true
        },
        {
          text: this.$t("admin.user.email"),
          value: "email",
          inputtype: "TEXT",
          maxlength: 50,
          required: true
        },
        {
          text: this.$t("admin.user.password"),
          value: "password",
          inputtype: "TEXT",
          maxlength: 32,
          password: true
        },
        {
          text: this.$t("admin.user.lang"),
          value: "lang",
          inputtype: "LOOKUP",
          values: this.languages,
          required: true
        },
        {
          text: this.$t("admin.user.admin"),
          value: "isadmin",
          inputtype: "CHECKBOX"
        }
      ];
    },
    languages() {
      return this.getLanguages.map(lng => {
        let l = {"value": lng.lang, "text": lng.name}
        return l
      })
    }
  },
  methods: {
    ...mapActions([
      "doAdminLoadUsers",
      "doAdminCreateUser",
      "doAdminUpdateUser",
      "doAdminDeleteUser",
    ]),
    ...mapMutations(["mShowLongLoader", "mHideLongLoader", "mShowInfoMessage"]),
    async createUser(user) {
      this.$log.debug("doAdminCreateUser", user);
      this.doAdminCreateUser(user);
    },
    async updateUser(user) {
      this.mShowLongLoader(this.$i18n.t("common.deleting"));
      this.$log.debug("doAdminUpdateUser", user);
      this.doAdminUpdateUser(user);
      this.mHideLongLoader();
    },
    async deleteUser(user) {
      this.mShowLongLoader(this.$i18n.t("common.deleting"));
      this.$log.debug("doAdminDeleteUser", user);
      await this.doAdminDeleteUser(user);
      this.mHideLongLoader();
    }
  },
  async beforeRouteEnter(to, from, next) {
    Vue.$log.info("AdminUsers: BEFORE ROUTE ENTER");
    store.commit("mShowLongLoader", VueI18n.t("common.pleasewait"));
    await store.dispatch("doAdminLoadUsers")
    next();
  }
};
</script>

<style>
</style>